var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{ref:"locationEdit",attrs:{"loading":_vm.loading,"items":_vm.locations,"item-text":"name","return-object":""},on:{"change":_vm.onClick},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-list-tile-title',[_vm._v(" "+_vm._s(item.name)+" ")])]}}]),model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}})}
var staticRenderFns = []

export { render, staticRenderFns }